module.exports = __webpack_public_path__ + "static/media/minus.5153ea02.svg";